export default {
    'en_CA': 'English (Canada)',
    'en_US': 'English (United States)',
    'en_GB': 'English (Great Britain)',
    'fr_CA': 'French (Canada)',
    'fr_FR': 'French (France)',
	'fr_BE': 'French (Belgium)',
	'fr_MA': 'French (Morocco)',
    'pt_PT': 'Portuguese (Portugal)',
	'el_GR': 'Greek (Greece)',
	'es_ES': 'Spanish (Spain)',
	'es_MX': 'Spanish (Mexico)',
	'es_CO': 'Spanish (Colombia)',
	'nl_BE': 'Dutch (Belgium)',
	'pt_BR': 'Portuguese (Brazil)',
	'sk_SK': 'Slovak (Slovakia)',
	'sr_RS': 'Serbian (Serbia)',
	'tr_TR': 'Turkish (Turkey)',
    'fi_FI': 'Finnish (Finland)',
    'sv_SE': 'Swedish (Sweden)',
    // GAME_SUSPENDED_MESSAGE: 'Game {0} is currently suspended...',  {0} = game name EXAMPLE WITH WILD CARD market types
    WIN_DRAW_WIN: 'Ottelun tulos',
    CORRECT_SCORE: 'Oikea tulos',
    TOTAL_GOALS: 'Maaleja yhteensä',
    DOUBLE_CHANCE: 'Tuplamahdollisuus',
    UNDER_OVER: 'Yli/alle',
    UNDER_OVER_25: 'Y/A 2,5',
    UNDER_OVER_25_INITIALS: 'Y/A 2,5',
    UNDER_OVER_35_INITIALS: 'Y/A 3,5',
    UNDER_OVER_15: 'Y/A 1,5',
    ASIAN_HANDICAP: 'Asian Handicap',
    HANDICAP: '1X2 tasoitus',
    HANDICAP_FIRST: '1X2 tasoitus koti +1',
    HANDICAP_SECOND: '1X2 tasoitus vieras +1',
    UNDER_OVER_05: 'A/Y 0,5',
    UNDER_OVER_35: 'Y/A 3,5',
    BOTH_TEAMS_SCORE: 'Molemmat tekevät maalin',
    BOTH_TEAMS_SCORE_INITIALS: 'BTTS',
    HOME_TEAM_GOALS: '{0} Team Goals',
    AWAY_TEAM_GOALS: '{1} Team Goals',
    MATCH_BETTING_BOTH_TEAMS_SCORE: 'Match Betting Both Teams Score',
    WINNING_MARGIN: 'Voittomarginaali',
    CORRECT_SCORE_GROUP: 'Oikea tulosryhmä',
    HOME_TEAM_TO_SCORE: '{0} To Score',
    AWAY_TEAM_TO_SCORE: '{1} To Score',
    FIRST_TEAM_TO_SCORE: 'Ensimmäinen pisteen tekevä joukkue',
    LAST_TEAM_TO_SCORE: 'Viimeinen pisteen tekevä joukkue',
    HALF_TIME_FULL_TIME: 'Puoliaika Koko aika',
    TEAM_SCORECAST: 'Team Scorecast',
    HALF_TIME_CORRECT_SCORE: 'Half Time Correct Score',
    HALF_TIME_RESULT: 'Half Time Result',
    FIRST_LAST_TO_SCORE: 'First / Last to Score',
    LAST: 'Last',
    FIRST: 'First',
    IN: 'in',
    LAST_THREE_GAMES: 'Last 3 Games',
    PREVIOUS: 'Edellinen',
    EIGHT_RESULTS: '8 ottelua',
    EIGHT_GAMES: '8 peliä',
    OVER_25: 'Yli 2,5',
    UNDER_25: 'alle 2,5',
    OVER_35: 'Yli 3,5',
    UNDER_35: 'alle 3,5',
    COVERED: 'Katettu',
    DID_NOT_COVER: 'Ei katettu',
    SPREAD: 'Piste-ero',
    TOTAL_POINTS_UNDER_OVER: 'Yhteispisteet alle/yli',
    TOTAL_POINTS_OVER_UNDER: 'Yhteispisteet yli/alle',
    MONEYLINE: 'Rahalinja',
    TOTAL_POINTS_GROUP: 'Yhteispisteryhmä',
    MONEY_LINE_TOTAL_POINTS: 'Rahalinja ja yhteispisteet Y/A',
    SPREAD_TOTAL_POINTS: 'Piste-ero ja yhteispisteet Y/A',
    // countries (these are lowecase and strings on purpose)
    'Argentina': 'Argentina',
    'Belgium': 'Belgium',
    'Brazil': 'Brazil',
    'Colombia': 'Colombia',
    'Costa Rica': 'Costa Rica',
    'Croatia': 'Croatia',
    'Czech Republic': 'Czech Republic',
    'Denmark': 'Denmark',
    'Egypt': 'Egypt',
    'England': 'England',
    'France': 'France',
    'Germany': 'Germany',
    'Greece': 'Greece',
    'Holland': 'Holland',
    'Iceland': 'Iceland',
    'Italy': 'Italy',
    'Mexico': 'Mexico',
    'Poland': 'Poland',
    'Portugal': 'Portugal',
    'Republic of Ireland': 'Republic of Ireland',
    'Russia': 'Russia',
    'Spain': 'Spain',
    'Sweden': 'Sweden',
    'Switzerland': 'Switzerland',
    'Ukraine': 'Ukraine',
    'Uruguay': 'Uruguay',
    //Basketball US Teams
    'Boston': 'Boston',
    'Cleveland': 'Cleveland',
    'Houston': 'Houston',
    'Los Angeles': 'Los Angeles',
    'Orlando': 'Orlando',
    'Portland': 'Portland',
    'San Antonio': 'San Antonio',
    //Basketball Euro Teams
    'Euro Arena': 'Euro Arena',
    'Athens': 'Athens',
    'Real': 'Real',
    'Piraeus': 'Piraeus',
    'Istanbul Blues': 'Istanbul Blues',
    'Fener': 'Fener',
    'Vitoria': 'Vitoria',
    'Tel Aviv Yellows': 'Tel Aviv Yellows',
    'Moscow': 'Moscow',
    'Kaunas': 'Kaunas',
    'Barcelona City': 'Barcelona City',
    'Belgrade': 'Belgrade',
    'Lyon': 'Lyon',
    'Khimki': 'Khimki',
    'Berlin': 'Berlin',
    'St Petersburg': 'St Petersburg',
    'Valencia': 'Valencia',
    //Euro 2020 teams
    'Turkey': 'Turkey',
    'Netherlands': 'Netherlands',
    //Super league
    'Utd': 'United',
    'City': 'City',
    'Liverpool': 'Liverpool',
    'Barcelona': 'Barcelona',
    'Madrid': 'Madrid',
    'Munich': 'Munich',
    'Turin': 'Turin',
    'Milan': 'Milan',
    'Amsterdam': 'Amsterdam',
    'Paris': 'Paris',
    //NFLA
    'Pittsburgh': 'Pittsburgh',
    'Philadelphia': 'Philadelphia',
    'Denver': 'Denver',
    'New York': 'New York',
    'New England': 'New England',
    'Green Bay': 'Green Bay',
    'San Francisco': 'San Francisco',
    'Miami': 'Miami',
    'Dallas': 'Dallas',
    'Oakland': 'Oakland',
    'Chicago': 'Chicago',
    // market specific words
    'DRAW': 'Tasapeli',
    'HD': '{0}/Tasapeli',
    'DA': 'Tasapeli/{1}',
    'HA': '{0}/{1}',
    'Under 2.5': 'alle 2,5',
    'Over 2.5': 'Yli 2,5',
    'Under 1.5': 'alle 1,5',
    'Over 1.5': 'Yli 1,5',
    'Under': 'Alle {0}',
    'Over': 'Yli {0}',
    'HOME': '{0}',
    'AWAY': '{1}',
    'Under 0.5': 'alle 0,5',
    'Over 0.5': 'Yli 0,5',
    'Under 3.5': 'alle 3,5',
    'Over 3.5': 'Yli 3,5',
    'Both Score Yes': 'Kyllä',
    'Both Score No': 'Ei',
    'Home Not to Score': '{0} Not to Score',
    'Home Exactly 1': '{0} Exactly 1',
    'Home Exactly 2': '{0} Exactly 2',
    'Home Exactly 3': '{0} Exactly 3',
    'Home Exactly 4': '{0} Exactly 4',
    'Away Not to Score': '{1} Not to Score',
    'Away Exactly 1': '{1} Exactly 1',
    'Away Exactly 2': '{1} Exactly 2',
    'Away Exactly 3': '{1} Exactly 3',
    'Away Exactly 4': '{1} Exactly 4',
    'Home to Win and both teams to score': '{0} to Win and both teams to score',
    'Home to Win to nil': '{0} to Win to nil',
    'Score draw': 'Tie game',
    '0-0': '0-0',
    '0-1': '0-1',
    '0-2': '0-2',
    '0-3': '0-3',
    '0-4': '0-4',
    '0-5': '0-5',
    '0-6': '0-6',
    '1-0': '1-0',
    '2-0': '2-0',
    '3-0': '3-0',
    '4-0': '4-0',
    '5-0': '5-0',
    '6-0': '6-0',
    '1-1': '1-1',
    '2-2': '2-2',
    '3-3': '3-3',
    '2-1': '2-1',
    '1-2': '1-2',
    '3-1': '3-1',
    '1-3': '1-3',
    '3-2': '3-2',
    '2-3': '2-3',
    '4-1': '4-1',
    '1-4': '1-4',
    '4-2': '4-2',
    '2-4': '2-4',
    '5-1': '5-1',
    '1-5': '1-5',
    '1-0,2-0,2-1': '1-0,2-0,2-1',
    '3-0,3-1,4-0': '3-0,3-1,4-0',
    '1-1,2-2': '1-1,2-2',
    '0-1,0-2,1-2': '0-1,0-2,1-2',
    '0-3,1-3,0-4': '0-3,1-3,0-4',
    'Away to Win and both teams to score': '{1} to Win and both teams to score',
    'Away to Win to nil': '{1} to Win to nil',
    'Home Win By Exactly 1 Goal': '{0} Win By Exactly 1 Goal',
    'Home Win By Exactly 2 Goals': '{0} Win By Exactly 2 Goals',
    'Home Win By 3 or more goals': '{0} Win By 3 or more goals',
    'Away Win By Exactly 1 Goal': '{1} Win By Exactly 1 Goal',
    'Away Win By Exactly 2 Goals': '{1} Win By Exactly 2 Goals',
    'Away Win By 3 or more goals': '{1} Win By 3 or more goals',
    'Draw With No Goals': 'Tie With No Goals',
    'Draw With Goals': 'Tie With Goals',
    'Any Other': 'Any Other',
    'Home Not To Score': '{0} Not To Score',
    'Home To Score': '{0} To Score',
    'Away Not To Score': '{1} Not To Score',
    'Away To Score': '{1} To Score',
    'Home': '{0}',
    'No Goal': 'No Goal',
    'Away': '{1}',
    'Home/Home': '{0}/{0}',
    'Home/Draw': '{0}/Tie',
    'Home/Away': '{0}/{1}',
    'Draw/Home': 'Tie/{0}',
    'Draw/Draw': 'Tie/Tie',
    'Draw/Away': 'Tie/{1}',
    'Away/Home': '{1}/{0}',
    'Away/Draw': '{1}/Tie',
    'Away/Away': '{1}/{1}',
    'Home and 1-0': '{0} and 1-0',
    'Home and 2-0': '{0} and 2-0',
    'Home and 2-1': '{0} and 2-1',
    'Away and 2-1': '{1} and 2-1',
    'Home and 3-0': '{0} and 3-0',
    'Home and 3-1': '{0} and 3-1',
    'Away and 3-1': '{1} and 3-1',
    'Home and 4-0': '{0} and 4-0',
    'Home and 1-1': '{0} and 1-1',
    'Away and 1-1': '{1} and 1-1',
    'Home and 2-2': '{0} and 2-2',
    'Away and 2-2': '{1} and 2-2',
    'Away and 0-1': '{1} and 0-1',
    'Away and 0-2': '{1} and 0-2',
    'Away and 1-2': '{1} and 1-2',
    'Home and 1-2': '{0} and 1-2',
    'Away and 0-3': '{1} and 0-3',
    'Away and 1-3': '{1} and 1-3',
    'Home and 1-3': '{0} and 1-3',
    'Away and 0-4': '{1} and 0-4',
    'Other': 'Other',
    'Draw': 'Tie',
    // Basketball
    '120-124': '120-124',
    '125-129': '125-129',
    '130-134': '130-134',
    '135-139': '135-139',
    '140-144': '140-144',
    '145-149': '145-149',
    '150-154': '150-154',
    '155-159': '155-159',
    '160-164': '160-164',
    '165-169': '165-169',
    '170-174': '170-174',
    '175-179': '175-179',
    'Under 180': 'alle 180',
    '180-184': '180-184',
    '185-189': '185-189',
    '190-194': '190-194',
    '195-199': '195-199',
    '200-204': '200-204',
    '205-209': '205-209',
    '210-214': '210-214',
    '215-219': '215-219',
    '220-224': '220-224',
    '225-229': '225-229',
    '230-234': '230-234',
    '235-239': '235-239',
    '240-244': '240-244',
    '245-249': '245-249',
    'Over 249': 'Yli 249',
//American Football
    '26-30': '26-30',
    '31-35': '31-35',
    '36-40': '36-40',
    '41-45': '41-45',
    '46-50': '46-50',
    '25 And Under': 'alle 26',
    '25 And Under Short': 'alle 26',
    '51 And Over': 'Yli 50',
    '51 And Over Short': 'Yli 50',
    'and': '&',
    'slash': '/',
    // first down
    FIRST_PLAY: '1st Play',
    SECOND_PLAY: '2nd Play',
    THIRD_PLAY: '3rd Play',
    FOURTH_PLAY: '4th Play',
    FIFTH_PLAY: '5th or More Play',
    FIELD_GOAL: 'Field Goal',
    'PassTD on 1st Play': 'PassTD on 1st Play',
    'PassTD on 2nd Play': 'PassTD on 2nd Play',
    'PassTD on 3rd Play': 'PassTD on 3rd Play',
    'PassTD on 4th Play': 'PassTD on 4th Play',
    'PassTD on or after 5th Play': 'PassTD on or after 5th Play',
    'RunTD on 1st Play': 'RunTD on 1st Play',
    'RunTD on 2nd Play': 'RunTD on 2nd Play',
    'RunTD on 3rd Play': 'RunTD on 3rd Play',
    'RunTD on 4th Play': 'RunTD on 4th Play',
    'RunTD on or after 5th Play': 'RunTD on or after 5th Play',
    'Turnover on 1st Play': 'Turnover on 1st Play',
    'Turnover on 2nd Play': 'Turnover on 2nd Play',
    'Turnover on 3rd Play': 'Turnover on 3rd Play',
    'Turnover on 4th Play': 'Turnover on 4th Play',
    'Turnover on or after 5th Play': 'Turnover on or after 5th Play',
    'Field Goal': 'Field Goal',

    //Game Tabs
    'Football': 'Amerikkalainen',
    'Matchday': 'Ottelupäivä',
    'Basketball': 'Koripallo',
    'Dogs': 'Koirat',
    'Motor Racing': 'Moottoriurheilu',
    'Results': 'Tulokset',
    'Horses': 'Hevoset',
    'Soccer': 'Jalkapallo',
    'US Football': 'Am. Jalkapallo',
    'Marble Racing': 'Marmorikuulakisa',
    "Matchday_English": "Ottelupäivä",
    "Matchday_Turkish": "Ottelupäivä",
    "Matchday_Greek": "Ottelupäivä",

    //Game SubTabs
    'Soccer_Euro': 'Euro',
    'Soccer_Soccer3_Super_League': 'Superliiga',
    'Soccer_Soccer3_Greek_League': 'Kreikkalainen liiga',
    'Soccer_Super_League': 'Superliiga',
    'Soccer_World_Cup': 'Maailmancup',
    'Soccer_Soccer3_World_Cup': 'Maailmancup',
    'Horses_Sprints': 'Pikajuoksut',
    'Horses_Flats': 'Tasaiset',
    'Horses_Jumps': 'Hypyt',
    'Basketball_US1': 'US',
    'Basketball_US2': 'US2',
    'Basketball_Europe': 'Eurooppa',
    'Dogs_Flats': 'Tasaiset',
    'Dogs_City': 'Static Odds',
    'Motor_Racing_Stock_Cars': 'Vakioautot',
    'Motor_Racing_Indy_Cars': 'Indy-autot',
    'US_Football_NFLA': 'NFLA',
    'US_Football_NFL': 'NFL',
    'US_Football_Football': 'Jalkapallo',
    'Marble_Racing_Marbles': 'Marmorikuulat',
    'Marble_Racing_Marbles2': 'Hiekka',
    'Marble_Racing_Marbles_Euro': 'Euro-marmorikuulat',
    'Marble_Racing_Marbles_Halloween': 'Halloween',
    "Matchday_English_Matchday_English": "Ottelupäivä",
    "Matchday_Turkish_Matchday_Turkish": "Ottelupäivä",
    "Matchday_Greek_Matchday_Greek": "Ottelupäivä",

    //Racing
    FORECAST: 'Ennuste',
    TRICAST: 'Tricast',
    REVERSE_FORECAST: 'Yhdistelmäennuste',
    REVERSE_TRICAST: 'Yhdistelmä-Tricast',
    FIRST_ST: '1',
    SECOND_ND: '2',
    THIRD_RD: '3',
    RD: 'rd',
    ST: 'st',
    ND: 'nd',
    ANY: 'Mikä tahansa',
    TO_WIN: 'Voittoon',
    RACE_CARD: 'KISAKORTTI',
    EACH_WAY: 'Each-Way',
    EW: 'E/W',
    FORECAST_TRICAST: 'Ennuste/Tricast',
    EACH_WAY_ODDS_PLACE: 'E/W {0} 1-2',
    EACH_WAY_ODDS_SHOW: 'E/W {0} 1-2-3',
    EXPAND_ALL: 'Expand Markets',
    COLLAPSE_ALL: 'Collapse Markets',
    NUMBER: 'Numero',
    SORT_BY: 'Järjestele:',
    BET_SLIP: 'Vedonlyöntikuponki',
    CLOSE_BET_SLIP: 'Sulje',
    CLOSE_SLIP: 'Sulje',
    PLACED_BETS: 'Sijoittui',
    SETTLED_BETS: 'Selvitetty',
    SLIP: 'Kuponki',
    OPEN_BETS: 'Auki',
    CLEAR_SELECTIONS: 'Tyhjennä valinnat',
    ADD_TO_BET_SLIP: 'Lisää kupongille',
    NO_BETS: 'Ei vetoja',
    COMBINATION_TRICAST: 'Yhdistelmä-Tricast',
    COMBINATION_FORECAST: 'Yhdistelmäennuste',
    TOTAL_STAKE: 'Kokonaispanos',
    TOTAL_POTENTIAL_RETURNS: 'Mahdolliset tuotot yhteensä',
    N_A: 'N/A',
    PLACE_BETS: 'Aseta vedot',
    REMOVE_ALL: 'Poista kaikki',
    POT_RETURNS: 'Mahd. tuotot',
    RETURNED: 'Palautettu:',
    REFUNDED: 'Hyvitetty',
    OK: 'OK',
    WIN_INITIAL: 'V',
    DRAW_INITIAL: 'T',
    LOSE_INITIAL: 'H',

    //Settings
    SETTINGS: 'Asetukset',
    LANGUAGE: 'Kieli',
    LAYOUT: 'Asettelu',
    ODDS: 'Kertoimet',
    EN_GB: 'English UK',
    DECIMAL: 'Desimaali',
    FRACTIONAL: 'Murtoluku',
    AMERICAN: 'Amerikkalainen',
    SIMPLIFIED_DESKTOP: 'This is The main class for the desktop simplified UI',
    SIMPLIFIED_MOBILE: 'This is The main class for the mobile simplified UI',
    SHOW_VIDEO: 'Show Video',

    //Notifications
    ALERT_NOTIFICATION: 'Hälytys',
    WARNING_NOTIFICATION: 'Varoitus',
    WARNING_NOTIFICATION_REALITY_CHECK: 'Varoitus',
    INFO_NOTIFICATION: 'TIETOJA',
    SUCCESS_NOTIFICATION: 'Menestys',

    SELECTION_REMOVAL: 'Tämä osio poistetaan  ',
    SECONDS: '  sekunnin kuluttua',
    SECOND: '  sekunnin kuluttua',
    REMOVE_CLOSED_EVENTS: 'Poista suljetut tapahtumat',
    SET_VIDEO_ON_FUL_SCREEN: 'Set Video on Full Screen?',
    CANCEL: 'Peru',

    //Error codes
    INTERNAL_ERROR: 'Sisäinen virhe',
    OPEN_BETS_WARNING: 'Osa avoimista vedoista tai kaikki niistä jätettiin pois pelikortilta, sillä ne kuuluvat edellisiin tapahtumiin.',
    '-32602': 'Ainakin yhtä vetoa ei lyöty lukkoon ajoissa.',
    OPEN_BETS_ON_BET_SLIP_LIMIT_REACHED: 'Kupongin vedot ‑välilehden vetojen enimmäismäärä on saavutettu. Poista vetoja tai tee niitä ennen kuin lisäät uusia vetoja.',

    '-20000': 'Cannot establish connection (Error Code: -20000)', //INIT_NOT_INVOKED
    '-20001': 'Cannot establish connection (Error Code: -20001)', //MISSING_SESSION_TOKEN
    '-20002': 'Too many requests (Error Code: -20002)', //Duplicate single shot invocation
    '-20003': 'Too many requests (Error Code: -20003)', //INVOCATION_FREQUENCY_THRESHOLD_BREACHED
    '-20004': 'Invalid Request (Error Code: -20004)', //A BmsServerAPI command was received, but the params are not compliant with Operator rules.
    '-10000': 'Invalid Request (Error Code: -10000)', //INVALID_SESSION_TOKEN
    '-10001': 'Invalid Request (Error Code: -10001)', //INBOUND_MESSAGE_QUEUE_FULL
    '-1000': 'Peli on keskeytetty. Ota yhteys asiakastukeen.',
    '-999': 'Istunto vanhentunut.',
    '-998': 'Pelaaja keskeytetty',
    '-997': 'Komentoa ei sallita',
    '-996': 'Error processing request (Error Code: -996)', //Gaming System Error
    '-995': 'Error processing request (Error Code: -995)', //BMS Internal Error
    '-994': 'Yhteys palvelimeen katkesi, vetoa ei tehty.',
    '-980': 'Error processing request (Error Code: -980)', //Error processing game command.
    '-979': 'Error processing request (Error Code: -979)', //Error on Json message sent by Virgo.
    '-978': 'Varat eivät riitä tämän maksun suorittamiseen.',
    '-977': 'Todellisuustarkistus epäonnistui.',
    '-976': 'Lompakon käyttö estetty tilapäisesti.',
    '-975': 'Panosrajoitus ylitetty.',
    '-974': 'Tappiorajoitus ylitetty.',
    '-973': 'Rajoitusta ei ole asetettu.',
    '-972': 'Vastuullisen uhkapelaamisen virhe.',
    '-971': 'Lompakon käyttö epäonnistui.',
    '-970': 'Lompakon maksu hylätty.',
    '-969': 'Lompakon viestintävirhe.',
    '-968': 'Lompakon maksuvirhe.',
    '-967': 'Todennus epäonnistui.',
    '-966': 'Korkean voiton kynnysarvo ylitetty.',
    '-965': 'Virheelliset parametrit.',

    // BET LIMITS ALERTS
    BET_STAKE_OUT_OF_LIMITS_MESSAGE: 'Ainakin yksi vedon panos ei ole kelvollinen. Minimipanos: {0}, Maksimipanos: {1}. Korjaa tilanne ennen kuin asetat panoksesi.',
    LIST_BET_STAKE_OUT_OF_LIMITS_MESSAGE: 'Stake limits on {0} are Min {1} & Max {2}',
    BET_POTENTIAL_RETURNS_OUT_OF_LIMITS_MESSAGE: 'Ainakin yhden vedon mahdolliset tuotot ylittivät {0} maksimimaksun. Korjaa tilanne ennen kuin asetat panoksesi.',
    BET_NON_DIVISIBLE_MESSAGE: 'Ainakaan yhtä panosta ei voi jakaa luvulla {0}. Korjaa tilanne ennen kuin asetat panoksesi.',
    SINGLE_BET_COMMIT_MESSAGE: 'Et voi asettaa useita yksittäisiä panoksia',
    REALITY_CHECK_WARNING_MESSAGE_LINE_1: 'Asettamasi panokset ovat suuruudeltaan yli {0}.',
    MIN_STAKE_REALITY_CHECK_WARNING_MESSAGE_LINE_1: 'The bet(s) you are placing are under {0}',
    REALITY_CHECK_WARNING_MESSAGE_LINE_2: 'Onko tämä OK',
    REALITY_CHECK_TOTAL_STAKE_SINGLE_EVENT_WARNING: '{0} suuruinen enimmäissumma on asetettu panokseksi. Valitse eri tapahtuma',

    //SIMPLIFIED UI
    TOTAL_BETS: 'KOKONAISPANOS:',
    PLACE_YOUR_BETS: 'Aseta panoksesi',
    RACE_START: 'Race Start',
    RACE_START_TIME: 'Start Time',
    BET_SUMMARY: 'Vetojen yhteenveto',
    NO_BETS_RESUME: 'Nykyiselle tapahtumalle ei tehty vetoja',
    LIVE: 'LIVE',
    RACERS: 'Kilpailijat',
    SELECTION: 'Valinnat',
    DATE_LOCATION: 'Tapahtuma',
    STAKE: 'Panos',
    BET_TYPE_STAKE: 'Vedon tyyppi / Panos',
    POTENTIAL_RETURNS: 'Mahd. tuotot',
    BET_HISTORY: 'Vetohistoria',
    BET_HISTORY_LABEL: 'Lisää historiatietoja saat klikkaamalla Historia-painiketta',
    FILTER_WINS: 'Suodata voitot',
    NEXT_RACE: 'Seuraava kisa',
    WIN: 'Voitto',
    PLACE: 'Sijoitus',
    SHOW: 'Näytä',
    EXACTA: 'Exacta',
    TRIFECTA: 'Tricast',
    NO_WIN: 'EI VOITTOA',
    WON: 'VOITTI',
    LOST: 'HÄVISI',
    CURRENT_RACE: 'Nykyinen kisa',
    BOX: 'BOX',
    TO: 'kohteelle',
    PAYS: 'pays',
    TRIFECTA_BOX: 'Tricast Boxed',
    EXACTA_BOX: 'Exacta Boxed',
    FINISH_YOUR_BETS: 'Viimeistele vetosi',
    SELECT_YOUR_BET_BELOW: 'Valitse vetosi alta',
    BET: 'veto',
    REMOVED: 'poistettu',
    RESULT: 'Tulos',
    GOALS: 'Maalit',
    NO_MORE_BETS: 'Ei enempää vetoja',
    EVENT_LIVE_MSG_LINE_1: 'Nykyinen tapahtuma live-tilassa',
    EVENT_LIVE_MSG_LINE_2: 'Valitse tulevaisuudesta  ',
    EVENT_LIVE_MSG_LINE_3: 'Tapahtumat yllä',
    NO_FUTURE_EVENTS: 'Ladataan',
    AUTHENTICATION_REQUIRED: 'Kirjaudu sisään jatkaaksesi',
    GAME_DISABLED: 'Peli poistettu käytöstä',
    GAME_DISABLED_MESSAGE: 'Ota yhteys asiakastukeen.',
    VOIDED: 'MITÄTÖITY',
    HELP: 'Tuki',
    LAST_RESULTS: 'Viimeiset tulokset',
    NO_LAST_RESULTS: 'Ei viimeisiä tuloksia',
    PREVIOUS_RESULTS: 'Edelliset tulokset',
    OFFENSE_PREVIOUS_RESULTS: 'Offense Previous Results',
    DEFENSE_PREVIOUS_RESULTS: 'Defense Previous Results',
    NO_LUCK: 'NO LUCK',
    THIS_TIME: 'THIS TIME',
    LOOK_FOR_THE_NEXT: 'Etsi seuraavaa',
    SCHEDULED_EVENT: 'aikataulun mukaista tapahtumaa',
    LOOK_FOR_THE: 'Etsi',
    NEXT_SCHEDULED: 'seuraavaa aikataulun mukaista',
    EVENT: 'tapahtumaa',
    RETURNS: 'TUOTOT',
    NEXT: 'Seuraava',
    FUTURE: 'Tulevaisuus',
    PLAYING: 'Pelaa',
    //MESSAGE BAR
    ON: 'kohteessa',
    MB_RACE_ON: 'kohteessa',
    MB_RACE_WIN: 'voittoon',
    MB_RACE_PLACE: 'sijoitukseen',
    MB_RACE_SHOW: 'näyttöön',
    MB_RACE_TRIFECTA_BOX: 'Tricast boxed',
    MB_RACE_EXACTA_BOX: 'exacta boxed',
    MB_RACE_EXACTA: 'exacta',
    MB_RACE_TRIFECTA: 'Tricast',
    MB_FOOTBALL_ON: 'kohteessa',

    // DESKTOP UI
    ADVERTISING_SPACE: 'ADVERTISING SPACE',
    CLEAR_LAST: 'Tyhjennä viimeinen',
    CLEAR_ALL: 'Tyhjennä kaikki',
    ACTIVE_BETS: 'Aktiiviset vedot',
    ONLY_SHOW_WINS: 'Näytä vain voitot',
    MORE: 'Lisää',
    BETS: 'Vedot',
    LOADING: 'Ladataan',
    BET_SELECTION_MESSAGE: 'Tee valintasi klikkaamalla kertoimia.',

    // BUTTONS
    SIMPLE: 'simple',
    EXOTIC: 'exotic',
    UNDO: 'undo',
    CLEAR: 'clear',
    HISTORY: 'historia',

    MARKETS: 'Markkinat',
    MAIN: 'Pääasiallinen',
    VS: 'vs.',
    AT: '@',
    SCORE: 'pisteet',
    DEFENDS: '(Defends) at',
    ATTACKS: '(Attacks) at',
    DETAILS: 'Tiedot',
    NO_GOALS: 'Ei maaleja',

    MAX_WINNINGS_REACHED: 'Voittojen enimmäismäärä saavutettu',
    MAX_WINNINGS_REACHED_TEXT: 'Nykyinen veto ylittää {0} suuruisen enimmäismaksun. Tälle vedolle sallittu suurin panos on {1}.',
    NO_CONNECTION_TITLE: 'Yhteys katkesi',
    NO_CONNECTION_TITLE_TEXT: 'Yhteys palvelimeen katkesi. Varmista, että verkkoyhteytesi on vakaa, ja päivitä sivu. Jos ongelma jatkuu, ota yhteys tukeen.',
    PLAYER_LOGGED_OTHER_PLACE_TITLE_TEXT: 'Yhteys katkesi. Käyttäjä muodosti yhteyden kahdesti.',
    BET_CONFIRMED_TEXT:'none',
    TAX_NOTIFICATION_TEXT: 'none',
    //Event title names
    //Football
    'THE MANOR GROUND': 'Berners Stadium',
    'METRO STADIUM': 'Metro Stadium',

    //Horses Sprints
    'HorsesSprints': 'Wetmore Sprints',
    'Showell Park': 'Showell Park',
    '2FurlongHorses': 'Wetmore Sprints',
    'Sandringham Flats': 'Sandringham Flats',
    'Princess Parkway': 'Princess Parkway',

    //Horses Jumps
    'HorsesJumps': 'Inspired Downs',

    //BasketBall
    'Virtual Arena': 'Virtual Arena',
    'Inspired Arena': 'Inspired Arena',

    //Dogs
    'DogFlat': 'Barking Green',
    'Dogs2': 'Barking Green',
    'Victoria Park': 'Victoria Park',
    'Jennison Stadium': 'Jennison Stadium',

    //Motor Racing
    'Circuit': 'Circuit',

    //Speedway Park
    'Speedway Park': 'Inspired Raceway',
    'Auto Raceway': 'Auto Raceway',

    'NO_CONNECTION_TO_VIRGO': 'Yhteys katkesi',
    'NO_CONNECTION_TO_VIRGO_TEXT': 'Päivitä sivu ja kirjaudu sisään.',
    'BROWSER_NOT_SUPPORTED_DETAILS': 'Nykyistä selaintasi ei tueta. Käytä yhtä näistä selaimista: Chrome, Firefox tai Safari.',
    'BROWSER_NOT_SUPPORTED': 'Selainta ei tueta',
    'DOWNLOAD_CHROME': 'Lataa Chrome',
    'DOWNLOAD_FIREFOX': 'Lataa Firefox',
    'v': 'V',
    '1': '1',
    'x': 'x',
    '2': '2',
    'at': '@',
    '+10.5': '+10,5',
    '+15.5': '+15,5',
    '+5.5': '+5,5',
    '-10.5': '-10,5',
    '-15.5': '-15,5',
    '-5.5': '-5,5',
    'Over 219.5': 'Yli 219,5',
    'Under 219.5': 'alle 219,5',
    'Over 214.5': 'Yli 214,5',
    'Under 214.5': 'alle 214,5',
    'Over 209.5': 'Yli 209,5',
    'Under 209.5': 'alle 209,5',
    'Over 144.5': 'Yli 144,5',
    'Under 144.5': 'alle 144,5',
    'Over 149.5': 'Yli 149,5',
    'Under 149.5': 'alle 149,5',
    'Over 154.5': 'Yli 154,5',
    'Under 154.5': 'alle 154,5',
    'Over 159.5': 'Yli 159,5',
    'Under 159.5': 'alle 159,5',
    'Over 164.5': 'Yli 164,5',
    'Under 164.5': 'alle 164,5',
    'Rolling Downs': 'Rolling Downs',
    'FINISHING_ORDER': 'Lopullinen järjestys',
    'FORECAST_MARBLE': 'Ensimmäiset 2',
    'TRICAST_MARBLE': 'Ensimmäiset 3',
    'REVERSE_FORECAST_MARBLE': 'Ensimmäiset 2 missä tahansa järjestyksessä',
    'REVERSE_TRICAST_MARBLE': 'Ensimmäiset 3 missä tahansa järjestyksessä',
    'TO_WIN_MARBLE': 'Voitto',
    'PLACE_MARBLE': 'Sijoitus',
    'SHOW_MARBLE': 'Näytä',
    'MARBLE': 'Marble',
    'Rumble Turns': 'Rumble Turns',
    'Maple Downs': 'Maple Downs',

    //Header
    'BALANCE': 'Tasapaino',
    'DATE_FORMAT': 'MM/DD/YYYY HH:mm',
    'WINS_THE_GAME': 'Wins The Game',
    'Any': 'Kaikki',
    "BET_BOTH": "Lyö vetoa molemmista",
    //Matchday
    "betSlip_Matchday_English": "Ottelupäivä",
    "betSlip_Matchday_Turkish": "Ottelupäivä",
    "betSlip_Matchday_Greek": "Ottelupäivä",
    "betSlip_Soccer": "Jalkapallo",
    "betSlip_Horses": "Hevoset",
    "betSlip_Basketball": "Koripallo",
    "betSlip_Dogs": "Koirat",
    "betSlip_Motor Racing": "Moottoriurheilu",
    "betSlip_US Football": "Am. Jalkapallo",
    "betSlip_Marble Racing": "Marmorikuulakisa",
    "POS": "sij",
    "TEAM": "joukkue",
    "P": "p",
    "W": "w",
    "D": "d",
    "L": "l",
    "F": "f",
    "A": "a",
    "PTS": "pist",
    "LEAGUE TABLE": "sarjataulukko",
    "TREND": "trendi",


    //Matchday English Teams
    "Matchday_Islington": "ISL",
    "Matchday_City": "CTY",
    "Matchday_Palace": "PAL",
    "Matchday_Chelsea": "CHE",
    "Matchday_Southampton": "SOU",
    "Matchday_Wolverhampton": "WOL",
    "Matchday_Sheffield": "SHE",
    "Matchday_Leicester": "LEI",
    "Matchday_Newcastle": "NEW",
    "Matchday_Tottenham": "TOT",
    "Matchday_West Ham": "WHA",
    "Matchday_United": "UTD",
    "Matchday_Leeds": "LEE",
    "Matchday_Liverpool": "LIV",
    "Matchday_Everton": "EVE",
    "Matchday_Aston": "AST",

    //Matchday Turkish Teams
    "Matchday_Basaksehir": "BAS",
    "Matchday_Trabzon": "TRZ",
    "Matchday_Besiktas": "BKS",
    "Matchday_Sivas": "SIV",
    "Matchday_Alanya": "ALA",
    "Matchday_Galata": "GLS",
    "Matchday_Fenerbahce": "FRB",
    "Matchday_Gazientep": "GAZ",
    "Matchday_Antalya": "ANT",
    "Matchday_Kasimpasa": "KAS",
    "Matchday_Goztepe": "GOZ",
    "Matchday_Gencler": "ESK",
    "Matchday_Konya": "BUR",
    "Matchday_Rize": "RIZ",
    "Matchday_Malatya": "MAL",
    "Matchday_Kayseri": "KAY",

    //Matchday Greek Teams
    "Matchday_Dikefalos Vora": "ΔΙΚ",
    "Matchday_Erithrolefkoi": "ΘΡΥ",
    "Matchday_Enosi": "ΕΝΩ",
    "Matchday_Peristeri": "ΠΕΡ",
    "Matchday_Prasinoi": "ΠΡΑ",
    "Matchday_Kitrinoi Vora": "ΚΙΤ",
    "Matchday_Nea Smirni": "ΣΜΥ",
    "Matchday_Xanthi": "ΞΑΝ",
    "Matchday_Tripoli": "ΤΡΙ",
    "Matchday_Agrinio": "ΑΓΡ",
    "Matchday_Larisa": "ΛΑΡ",
    "Matchday_Lamia": "ΛΑΜ",
    "Matchday_Ioannina": "ΙΩΑ",
    "Matchday_Iraklio": "ΗΡΑ",
    "Matchday_A.O. Rizoupolis": "ΡΙΖ",
    "Matchday_Volos": "ΒΟΛ",

//Soccer3 Greek Teams
    "Dikefalos Vora": "ΔΙΚ",
    "Erithrolefkoi": "ΘΡΥ",
    "Enosi": "ΕΝΩ",
    "Peristeri": "ΠΕΡ",
    "Prasinoi": "ΠΡΑ",
    "Kitrinoi Vora": "ΚΙΤ",
    "Nea Smirni": "ΣΜΥ",
    "Xanthi": "ΞΑΝ",
    "Tripoli": "ΤΡΙ",
    "Agrinio": "ΑΓΡ",
    "Larisa": "ΛΑΡ",
    "Lamia": "ΛΑΜ",
    "Ioannina": "ΙΩΑ",
    "Iraklio": "ΗΡΑ",
    "A.O. Rizoupolis": "ΡΙΖ",
    "Volos": "ΒΟΛ",

    "Dortmund": "Dortmund",
    "Chelsea": "Chelsea",
    "Porto": "Porto",
    "Rome": "Rome",
    "Benfica": "Benfica",
    "Celtic": "Celtic",
    "United": "United",
    UNDER_OVER_MATCHDAY: 'Yli/alle',
    UNDER_OVER_05_SHORT: "0,5",
    UNDER_OVER_25_SHORT: "2,5",
    UNDER_OVER_35_SHORT: "3,5",
    UNDER_OVER_15_SHORT: "1,5",
    UNDER_SHORT: "A",
    OVER_SHORT: "Y",
    "FULL TIME": "TÄYSI AIKA",
    "FT": "TA",
    "System": "JÄRJESTELMÄ",
    "x1": "(x1)",
    "Multiplier": "Repeat Bet",
    "Main markets": "YLEISET KOHTEET",
    "4RANDOM": "4 SATUNNAISTA",
    "6RANDOM": "6 SATUNNAISTA",
    "8RANDOM": "8 SATUNNAISTA",
    "8FAVS": "8 SUOSIKKIA",
    "QUICK_SELECT": "PIKAVALINTA",
    "UNDER": "alle",
    "OVER": "Yli",
    "UNDER_OVER_2_5": "Yli/alle 2,5",
    "UNDER_OVER_3_5": "Yli/alle 3,5",
    "MATCH_RESULT": "MOttelun tulos",
    "YES": "Kyllä",
    "NO": "Ei",
    "REALITY_CHECK_WARNING_YES": "Kyllä",
    "REALITY_CHECK_WARNING_NO": "Ei",
    "ACCUMULATOR": "Tasoitus",
    "+1G": "+1G",
    "Single": "Yksittäinen",
    "Doubles": "Tupla(t)",
    "Trebles": "Kolminkertaiset",
    "Four Folds": "Nelinkertaiset",
    "Five Folds": "Viisinkertaiset",
    "Six Folds": "Kuusinkertaiset",
    "Seven Folds": "Seitsenkertaiset",
    "Eight Folds": "Kahdeksankertaiset",
    "MD": "MD{0}",
    "MATCH": "OTTELU",
    "INVALID_ACCA": "Kun valintasi näkyvät korostettuina, moninkertaiset valintasi on rajoitettu",
    "INVALID_ODDS": "Kertoimien arvo on liian korkea. Muuta valintojasi",
    "INVALID_ACCA_MORETHAN_8": "Moninkertaisissa vedoissa voi olla enintään 8 valintaa yksittäisestä ottelusta",

    // Accumulator Boost
    "ACCUMULATOR_BOOST": 'Tasoituksen tehostus',
    "Bonus_Info": " {0}% Bonus",
    "+": "+",
    "Bonus_Value": "Sis. {0} bonus",
    "ACCUMULATOR_INFO": 'Jos tasoitusvetosi onnistuu, tuottoihisi lisätään {0}% - {1}% bonus. Bonussumma riippuu valintojen määrästä.',
    "BET_TYPE": 'Vedon tyyppi',
    "BOOST": 'Tehosta',
    "BOOST_PERCENTAGE": '{0}%',
    "BOOST_BONUS_START": '{0} tai useampi tasoitusvalinta saa bonuksen',
    "BOOST_BONUS_UPGRADE": 'Lisää toinen tasoitusvalinta saadaksesi lisäbonuksen',
    "BOOST_BONUS_MAX": 'Sinulla on suurin mahdollinen tasoitusbonus',
    "Marbles_Euro_1": "Belgium",
    "Marbles_Euro_2": "Croatia",
    "Marbles_Euro_3": "Denmark",
    "Marbles_Euro_4": "England",
    "Marbles_Euro_5": "France",
    "Marbles_Euro_6": "Germany",
    "Marbles_Euro_7": "Italy",
    "Marbles_Euro_8": "Netherlands",
    "Marbles_Euro_9": "Portugal",
    "Marbles_Euro_10": "Spain",
    "Short_Over": "Yli {0}",
    "Short_Under": "alle {0}",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_1": "Rekisteröidy tai kirjaudu sisään, jotta voit tehdä vedon",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_2": " ",
    "DEMOPLAY_NOTIFICATION_DISMISS": "Hylkää",
    "DEMOPLAY_NOTIFICATION_OK": "OK",
    "Matchday_Moroccan": "Matchday Moroccan",
    "Matchday_Moroccan_Matchday_Moroccan": "Matchday Moroccan",
    "betSlip_Matchday_Moroccan": "Matchday Moroccan",

    //Matchday Moroccan Teams
    "Matchday_Casa Reds": "WYD",
    "Matchday_Casa Greens": "RAJ",
    "Matchday_Fès": "FES",
    "Matchday_El Jadida": "ELJ",
    "Matchday_Berkane": "BKN",
    "Matchday_Feth": "FTH",
    "Matchday_FARabat": "FAR",
    "Matchday_Mohammedia": "MOH",
    "Matchday_Soualem": "SLM",
    "Matchday_Khouribga": "KHO",
    "Matchday_Tanger": "TAN",
    "Matchday_Agadir": "AGA",
    "Matchday_Berrechid": "BER",
    "Matchday_Oujda": "OUJ",
    "Matchday_Safi": "SAF",
    "Matchday_Oued Zem": "ODZ",
    "Matchday_Tétouan": "TET",
    "Matchday_Touarga": "TRG",
    "Matchday_Beni Mellal": "BNM",
    "Matchday_Stade Maroc": "STM",
    "Matchday_Zemamra": "ZMR",

    "Soccer_Soccer3_Moroccan_League": "Moroccan",
    //Soccer3 Moroccan Teams
    "Casa Reds": "Casa Reds",
    "Casa Greens": "Casa Greens",
    "Fès": "Fès",
    "El Jadida": "El Jadida",
    "Berkane": "Berkane",
    "Feth": "Feth",
    "FARabat": "FARabat",
    "Mohammedia": "Mohammedia",
    "Soualem": "Soualem",
    "Khouribga": "Khouribga",
    "Tanger": "Tanger",
    "Agadir": "Agadir",
    "Berrechid": "Berrechid",
    "Oujda": "Oujda",
    "Safi": "Safi",
    "Oued Zem": "Oued Zem",
    "Tétouan": "Tétouan",
    "Touarga": "Touarga",
    "Beni Mellal": "Beni Mellal",
    "Stade Maroc": "Stade Maroc",
    "Zemamra": "Zemamra",
    "QUICK_FILL": "Quick Fill",
    "MAD" : "{0} MAD",

    //Matchday Belgium
    "Matchday_Belgium": "Matchday",
    "Matchday_Belgium_Matchday_Belgium": "Matchday",
    "betSlip_Matchday_Belgium": "Matchday Belgium",
    //Matchday Belgium Teams
    "Matchday_Saint-Gilles": "SAI",
    "Matchday_Club": "CLU",
    "Matchday_Anderlecht": "AND",
    "Matchday_Antwerp": "ANT",
    "Matchday_Gent": "GEN",
    "Matchday_Mechelen": "MEC",
    "Matchday_Charleroi": "CHA",
    "Matchday_Genk": "GNK",
    "Matchday_Brugge": "BRU",
    "Matchday_Sint-Truiden": "SIN",
    "Matchday_Leuven": "LEU",
    "Matchday_Kortrijk": "KOR",
    "Matchday_Liege": "LIE",
    "Matchday_Oostende": "OOS",
    "Matchday_Waregem": "WAR",
    "Matchday_Eupen": "EUP",
    "Matchday_Seraing": "SER",

    //BonusBet
    "Gift_for_You_Heading" :"LAHJA SINULLE",
    "Gift_for_You_Content": "Onneksi olkoon! Voit lunastaa mainostarjouksia.",
    "View_Offers" : "KATSO TARJOUKSET",
    "Do_Not_Show_MSG": " ÄLÄ NÄYTÄ UUDELLEEN",
    "MY_OFFERS" : 'TARJOUKSENI',
    "SELECT_OFFER" : 'VALITSE TARJOUKSESI',
    "NO_OFFER" : 'AKTIIVISIA TARJOUKSIA EI OLE',
    "CHOOSE_BET": 'VALITSE VETO',
    "Opt_In": 'HYVÄKSY',
    "Key_Terms_Heading" :"KESKEISET TERMIT",
    "No_Thanks" : "EI KIITOS",
    "PROMO_BET": 'KAMPANJAVETO',
    "Time_To_Bet": "AIKAA LYÖDÄ VETOA",
    "OPTED_IN_MSG": "KIITOS HYVÄKSYMISESTÄSI",
    "EXP": "Vanh..",
    "SELECT": "Select",
    "DEMO_SITE_PROMO_NOT_AVAILABLE": "This demo site does not currently offer any promos. Please log in/register to access current offers. !",
    "Horses_US_Horses": "USA",

    //cricket
    "Cricket" : "Kriketti",
    "Cricket_International": "Kansainvälinen",
    "betSlip_Cricket": "Kriketti",
    //circket teams
     "Australia":"Australia",
     "India":"India",
     "Pakistan":"Pakistan",
     "West Indies" : "West Indies",
     "Sri Lanka":"Sri Lanka",
     "New Zealand":"New Zealand",
     "South Africa":"South Africa",
     "Australia_short":"AUS",
     "WestIndies_short" : "WI",
     "SriLanka_short":"SRI",
     "NewZealand_short":"NZL",
     "India_short":"IND",
     "SouthAfrica_short":"RSA",
     "Pakistan_short":"PAK",
     "England_short": "ENG",
     "Tie":"Tie",
    //cricket markets
     "MATCH_WINNER":"Ottelun voittaja",
     "TOTAL_SIXES_IN_MATCH":"Otteluita 6 yhteensä",
     "TOTAL_SIXES_IN_MATCH_SHORT": "Under 1.5",
     "TOTAL_FOUR_IN_MATCH":"Otteluita 4 yhteensä",
     "TOTAL_BOUNDARIES_IN_MATCH":"Ottelurajoja yhteensä",
     "FIRST_TEAM_TOTAL_RUNS":"{0} Kertoja yhteensä",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL":"{0} Alkaa ensimmäisestä toimituksesta",
     "FIRST_TEAM_WICKET_LOST":"{0} Pesä menetetty",
     "FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE":"Ensimmäinen hylkäämistapa",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05_SHORT": "0.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15_SHORT": "1.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25_SHORT": "2.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35_SHORT": "3.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_UNDER_OVER":"{0} Runs Off First Delivery (O/U)",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05": "{0} Runs Off First Delivery (O/U)",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15": "{0} Runs Off First Delivery (O/U)",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25": "{0} Runs Off First Delivery (O/U)",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35": "{0} Runs Off First Delivery (O/U)",
     "Caught" : "Saatu kiinni",
     "Bowled":"Keilattu",
     "LBW":"LBW",
     "No Wicket":"Ei pesää",
     "OverZeroPointFive": "Over 0.5",
     "UnderZeroPointFive": "Under 0.5",
     "OverOnePointFive": "Over 1.5",
     "UnderOnePointFive": "Under 1.5",
     "OverTwoPointFive": "Over 2.5",
     "UnderTwoPointFive": "Under 2.5",
     "OverThreePointFive": "Over 3.5",
     "UnderThreePointFive": "Under 3.5",
     "Yes": "Yes",
     "No":"No",
     "FINAL_SCORE":"Final Score",
     OVER_145: 'Over 14.5',
     UNDER_145: 'Under 14.5',
     DRAW_Cricket: "DRAW",
      //TENNIS
    TOTAL_POINTS:"Yhteispisteet",
    HANDICAP_TENNIS: "Tasoitus",
    Scotland :"Scotland",
    USA: "USA",
    Tennis_International: "Kansainvälinen",
    betSlip_Tennis: "Tennis",
    "Win By 2 or 3": "Voitto vähintään 3 pisteellä",
    "Win By 4 or 5": "Voitto 4 tai 5 pisteellä",
    "Win By 6 or 7": "Voitto 6 tai 7 pisteellä",
    "Tennis": "Tennis",
   //baseball
    WINNER : "VOITTAJA",
    TOTAL_HOME_RUNS_UNDER_OVER: "YHTEISKUNNIAJUOKSUT Y/A",
    TOTAL_HOME_RUNS:  "YHTEISKUNNIAJUOKSUT TARKKA",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER:"VOITTAJA JA YHTEISKUNNIAJUOKSUT Y/A 5,5",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER_SHORT:"Voittaja ja yhteis-KJ:t Y/A 5,5",
    BATTER1_HOME_RUNS: " {0} KUNNIAJUOKSUA",
    BATTER2_HOME_RUNS: " {1} KUNNIAJUOKSUA",
    Baseball_HR_ShootOut_Legends: "Home Runs Shootout-Legends",
    Baseball_HR_ShootOut_Legends_SHORT: "HR Shootout",
    "Baseball": "Baseball",
    "betSlip_Baseball": "Baseball",
    "Player 1 AND OVER_5_5":"{0} ja yli 5,5",
    "Player 2 AND OVER_5_5":"{0} ja yli 5,5",
    "Player 1 AND UNDER_5_5":"{0} ja alle 5,5",
    "Player 2 AND UNDER_5_5":"{0} ja alle 5,5",
    "Draw AND OVER_5_5":"Tasapeli ja yli 5,5",
    "Draw AND UNDER_5_5":"Tasapeli ja alle 5,5",
    "HOME RUNS":" {0} KUNNIAJUOKSUA",
    "Next Fixtures":"Next Fixtures",
    "MATCH_IN_PROGRESS": "Match In Progress",
    "Matchday_Light_English": "Matchday Light",
    "Matchday_Light_English_Matchday_Light_English": "English League",
    "betSlip_Matchday_Light_English": "Matchday Light",

     //NFL
    'Cardinals' : 'Cardinals',
    'Falcons' : 'Falcons',
    'Ravens' : 'Ravens',
    'Bills' : 'Bills',
    'Panthers' : 'Panthers',
    'Bears' : 'Bears',
    'Bengals' : 'Bengals',
    'Browns' : 'Browns',
    'Cowboys' : 'Cowboys',
    'Broncos' : 'Broncos',
    'Lions' : 'Lions',
    'Packers' : 'Packers',
    'Texans' : 'Texans',
    'Colts' : 'Colts',
    'Jaguars' : 'Jaguars',
    'Chiefs' : 'Chiefs',
    'Raiders' : 'Raiders',
    'Chargers' : 'Chargers',
    'Rams' : 'Rams',
    'Dolphins' : 'Dolphins',
    'Vikings' : 'Vikings',
    'Patriots' : 'Patriots',
    'Saints' : 'Saints',
    'Giants' : 'Giants',
    'Jets' : 'Jets',
    'Eagles' : 'Eagles',
    'Steelers' : 'Steelers',
    '49ers' : '49ers',
    'Seahawks' : 'Seahawks',
    'Buccaneers' : 'Buccaneers',
    'Titans' : 'Titans',
    'Commanders' : 'Commanders',
    'NEW' : 'New',
    //Soccer_Soccer3_Turkish_League team names and game name
    "Soccer_Soccer3_Turkish_League": "Turkish League",
    "Basaksehir": "BAS",
    "Trabzon": "TRZ",
    "Besiktas": "BKS",
    "Sivas": "SIV",
    "Alanya": "ALA",
    "Galata": "GLS",
    "Fenerbahce": "FRB",
    "Gazientep": "GAZ",
    "Antalya": "ANT",
    "Kasimpasa": "KAS",
    "Goztepe": "GOZ",
    "Gencler": "ESK",
    "Konya": "BUR",
    "Rize": "RIZ",
    "Malatya": "MAL",
    "Kayseri": "KAY",

    //NBA 
  "Basketball_NBA": "NBA",
  "Atlanta Hawks": "Atlanta Hawks",
  "Boston Celtics": "Boston Celtics",
  "Brooklyn Nets": "Brooklyn Nets",
  "Charlotte Hornets": "Charlotte Hornets",
  "Chicago Bulls": "Chicago Bulls",
  "Cleveland Cavaliers": "Cleveland Cavaliers",
  "Dallas Mavericks": "Dallas Mavericks",
  "Denver Nuggets": "Denver Nuggets",
  "Detroit Pistons": "Detroit Pistons",
  "Golden State Warriors": "Golden State Warriors",
  "Houston Rockets": "Houston Rockets",
  "Indiana Pacers": "Indiana Pacers",
  "Los Angeles Clippers": "Los Angeles Clippers",
  "Los Angeles Lakers": "Los Angeles Lakers",
  "Memphis Grizzlies": "Memphis Grizzlies",
  "Miami Heat": "Miami Heat",
  "Milwaukee Bucks": "Milwaukee Bucks",
  "Minnesota Timberwolves": "Minnesota Timberwolves",
  "New Orleans Pelicans": "New Orleans Pelicans",
  "New York Knicks": "New York Knicks",
  "Oklahoma City Thunder": "Oklahoma City Thunder",
  "Orlando Magic": "Orlando Magic",
  "Philadelphia 76ers": "Philadelphia 76ers",
  "Phoenix Suns": "Phoenix Suns",
  "Portland Trail Blazers": "Portland Trail Blazers",
  "Sacramento Kings": "Sacramento Kings",
  "San Antonio Spurs": "San Antonio Spurs",
  "Toronto Raptors": "Toronto Raptors",
  "Utah Jazz": "Utah Jazz",
  "Washington Wizards": "Washington Wizards",
  "TOTALPOINTS": "TOTAL POINTS"
};


// WEBPACK FOOTER //
// ./src/localization/fi_FI.js